import axiosBase, { TypeOptions } from './axiosBase';

const url = 'https://price.vixs.vn';

const options: TypeOptions = {
    clientId: 'test1',
    isBasicAuth: true,
}

const instance = new axiosBase(url, options)

const instanceLog = instance.createInstance()

export default instanceLog;